<div class="col-lg-12">
    <div id="top-text-title">
        Contacts
    </div>
    <div id="text-content">
        <div class="row">
           <div class="col-lg-6 col-sm-12  small-center-align ">
                <div class="container">
                    <div class="justify-content-center align-self-center centered-contact-info">
                        <div id="contact-info">
                            <div> 
                                Address: Stara Zagora, Bulgaria
                            </div>
                            <div id="email-link"> 
                                Email: <a href="mailto:office@smartcenturytechnologies.com">office@smartcenturytechnologies.com</a>
                            </div>
                            <div id="phone-link">
                                Phone: <a href="tel:+359889668878">+(359) 889 66 88 78</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-sm-12">
                <div id="map" id="map"></div>
            </div>
        </div>
    </div>
</div>
